import { Link } from 'react-router-dom';
import './SolutionsOptions.css';
import imgSolar from '../../assets/sol_starting_scratch.png';
import imgBattery from '../../assets/battery_storage_house.png';

export default function SolutionsOptions() {
  return (
    <section className="sol-opts-section">
      <div className="sol-opts-inner">

        <div className="sol-opts-header">
          <h2 className="sol-opts-heading">Whether You're Starting Fresh or Upgrading Existing Solar</h2>
          <p className="sol-opts-subtitle">We design solar and battery systems based on your current setup, energy usage and long-term goals.</p>
        </div>

        <div className="sol-opts-grid">

          {/* Left pair: photo + card */}
          <div className="sol-opts-pair">
            <div className="sol-opts-photo sol-opts-photo--left">
              <img src={imgSolar} alt="House with solar panels" />
            </div>
            <div className="sol-opts-card">
              <div className="sol-opts-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <rect x="2" y="7" width="20" height="12" rx="2" stroke="#5a7a00" strokeWidth="1.8" />
                  <line x1="7" y1="7" x2="7" y2="19" stroke="#5a7a00" strokeWidth="1.8" />
                  <line x1="12" y1="7" x2="12" y2="19" stroke="#5a7a00" strokeWidth="1.8" />
                  <line x1="17" y1="7" x2="17" y2="19" stroke="#5a7a00" strokeWidth="1.8" />
                  <line x1="2" y1="13" x2="22" y2="13" stroke="#5a7a00" strokeWidth="1.8" />
                  <line x1="5" y1="7" x2="7" y2="3" stroke="#5a7a00" strokeWidth="1.8" strokeLinecap="round" />
                  <line x1="17" y1="7" x2="19" y2="3" stroke="#5a7a00" strokeWidth="1.8" strokeLinecap="round" />
                </svg>
              </div>
              <h3 className="sol-opts-card-heading">Starting From Scratch</h3>
              <p className="sol-opts-card-body">Install a complete solar and battery system designed to reduce electricity costs and maximise energy independence.</p>
              <Link to="/contact" className="sol-opts-btn">Explore Full Systems →</Link>
            </div>
          </div>

          {/* Right pair: card + photo */}
          <div className="sol-opts-pair">
            <div className="sol-opts-card">
              <div className="sol-opts-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <rect x="7" y="3" width="10" height="18" rx="2" stroke="#5a7a00" strokeWidth="1.8" />
                  <line x1="10" y1="1" x2="14" y2="1" stroke="#5a7a00" strokeWidth="1.8" strokeLinecap="round" />
                  <path d="M12 8v3l2 2" stroke="#5a7a00" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 className="sol-opts-card-heading">Upgrade Existing Solar System</h3>
              <p className="sol-opts-card-body">Already have solar panels? Add battery storage to keep more of the energy you generate and use it when prices are highest.</p>
              <Link to="/contact" className="sol-opts-btn">Explore Upgrade Options →</Link>
            </div>
            <div className="sol-opts-photo sol-opts-photo--right">
              <img src={imgBattery} alt="House with battery storage" />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
